import request from '../../axios';

export const getShopPosts = async (id: string, pageNumber: number) => {
  const {data}: {data: IStorePosts} = await request.get(
    `/api/v2/store/store-posts?supplier_guid=` + id + '&page=' + pageNumber,
  );
  return data;
};

export const getMyShopPosts = async (pageNumber: number , shelf : string) => {
  const {data}: {data: IStorePosts} = await request.get(
    `/api/v2/store/my-posts?profile_type=supplier&page=${pageNumber}${shelf && '&shelf=' + shelf}`,
  );
  return data;
};
